import React, { useEffect, useState } from "react";
import i18next from 'i18next';

const AccordionItem = ({ title, content, isOpen, onClick, }) => {
  return (
    <div className="border-b">
      <button
        className="w-full text-left p-4 font-medium flex justify-between items-center"
        onClick={onClick}
      >
        {title}
        <span>{isOpen ? "-" : "+"}</span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-40" : "max-h-0"
          }`}
      >
        <div className="p-4">{content}</div>
      </div>
    </div>
  );
};

const Accordion = ({ faqDetails }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [allLanguage, setAllLanguage] = useState("english");

  // Get handleSelectedLanguage from localStorage
  useEffect(() => {
    const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
    if (storeHandleSelectedLanguage) {
      setAllLanguage(storeHandleSelectedLanguage); // Update state
    }
  }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const data = faqDetails.map((items) => {
    // Find the translation that matches `allLanguage`
    const matchingTranslation = items.translations.find(
      (translation) => translation.language_name === (allLanguage === "english" ? "en" : "fr")
    );
    return {
      title: matchingTranslation?.question || "No question",
      content: matchingTranslation?.answer || "No answer",
    };
  });

  return (
    <div className="w-full  mx-auto mt-10 border rounded-lg shadow">
      {data.map((item, idx) => (
        <AccordionItem
          key={idx}
          title={item.title}
          content={item.content}
          isOpen={openIndex === idx}
          onClick={() => toggle(idx)}
        />
      ))}
    </div>
  );
};

export default Accordion;
